import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

const stats = [
  { value: '23+', label: 'Years of Experience' },
  { value: '400+', label: 'Projects Completed' },
  { value: '8', label: 'Core Services' },
  { value: '2,000+', label: 'Acres Improved' },
];

const clients = [
  { icon: 'ri-home-4-line', label: 'Homeowners' },
  { icon: 'ri-hammer-line', label: 'Home Builders' },
  { icon: 'ri-tools-fill', label: 'General Contractors' },
  { icon: 'ri-landscape-line', label: 'Landowners' },
  { icon: 'ri-crosshair-2-line', label: 'Hunters & Sportsmen' },
  { icon: 'ri-funds-line', label: 'Real Estate Investors' },
];

export default function About() {
  return (
    <div className="min-h-screen bg-brand-black font-body">
      <Navbar />

      {/* Page Header */}
      <section className="relative w-full pt-32 pb-20 px-6 lg:px-12 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/df2d9c4c84a75c1bddeb9f3a7d566cf3.jpg"
            alt="About Holston Land Management"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-brand-black/70" />
        </div>
        <div className="relative z-10 w-full max-w-7xl mx-auto">
          <p className="font-heading text-brand-green-accent text-xs tracking-[0.4em] uppercase mb-3">Who We Are</p>
          <h1 className="font-heading font-800 text-white text-6xl md:text-7xl tracking-widest uppercase">
            About Us
          </h1>
          <div className="w-12 h-0.5 bg-brand-green-accent mt-5" />
        </div>
      </section>

      {/* Stats Bar */}
      <section className="w-full bg-brand-green py-10 px-6 lg:px-12">
        <div className="w-full max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((s) => (
            <div key={s.label} className="text-center">
              <p className="font-heading font-800 text-white text-5xl tracking-wider">{s.value}</p>
              <p className="font-body text-xs text-green-200 tracking-widest uppercase mt-2">{s.label}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Main Content */}
      <main className="w-full px-6 lg:px-12 py-24">
        {/* Our Story — full width, no photos */}
        <div className="w-full max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row lg:items-end gap-6 mb-10">
            <div className="flex-1">
              <p className="font-heading text-brand-green-accent text-xs tracking-[0.4em] uppercase mb-3">Our Story</p>
              <h2 className="font-heading font-800 text-white text-4xl md:text-5xl lg:text-6xl tracking-widest uppercase leading-tight">
                Built on Experience<br />and Quality
              </h2>
            </div>
            <div className="w-10 h-0.5 bg-brand-green-accent lg:hidden" />
          </div>

          <div className="w-full h-px bg-brand-charcoal-mid mb-10" />

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 lg:gap-16">
            {/* Lead paragraph — wider, slightly larger text */}
            <div className="lg:col-span-1">
              <p className="font-body text-base text-gray-300 leading-relaxed border-l-2 border-brand-green-accent pl-5">
                Holston Land Management was founded on over two decades of experience in heavy equipment operations and land work. After years of working in large-scale industrial operations, we saw an opportunity to bring that same level of professionalism and capability to residential and commercial clients.
              </p>
            </div>
            {/* Supporting paragraphs */}
            <div className="lg:col-span-2 flex flex-col gap-6">
              <p className="font-body text-sm text-gray-400 leading-relaxed">
                Today we serve homeowners, builders, contractors, and landowners on projects of all sizes. Whether it&apos;s clearing a residential lot, prepping a commercial site, or building out a hunting property, we bring the same experience and attention to every project.
              </p>
              <p className="font-body text-sm text-gray-400 leading-relaxed">
                We&apos;re based in Northeast Tennessee and serve customers nationwide.
              </p>
            </div>
          </div>
        </div>

        {/* Who We Work With */}
        <div className="w-full max-w-7xl mx-auto mt-24">
          <div className="text-center mb-12">
            <p className="font-heading text-brand-green-accent text-xs tracking-[0.4em] uppercase mb-3">Who We Serve</p>
            <h2 className="font-heading font-800 text-white text-4xl md:text-5xl tracking-widest uppercase mb-4">
              We Work With
            </h2>
            <div className="w-12 h-0.5 bg-brand-green-accent mx-auto" />
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-px bg-brand-charcoal-mid">
            {clients.map((c) => (
              <div key={c.label} className="bg-brand-charcoal p-8 flex flex-col items-center gap-3 text-center">
                <div className="w-12 h-12 flex items-center justify-center border border-brand-green-mid rounded-sm">
                  <i className={`${c.icon} text-brand-green-accent text-2xl`} />
                </div>
                <p className="font-heading font-700 text-white text-sm tracking-wider uppercase">{c.label}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Location */}
        <div className="w-full max-w-7xl mx-auto mt-24 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="bg-brand-charcoal border border-brand-charcoal-mid p-10">
            <p className="font-heading text-brand-green-accent text-xs tracking-[0.4em] uppercase mb-3">Location</p>
            <h3 className="font-heading font-800 text-white text-3xl tracking-widest uppercase mb-6">
              Based in Northeast TN
            </h3>
            <div className="w-8 h-0.5 bg-brand-green-accent mb-6" />
            <p className="font-body text-sm text-gray-400 leading-relaxed mb-8">
              We're based in Northeast Tennessee and serve customers nationwide. Contact us to discuss your project. We're happy to talk through what you're looking to accomplish.
            </p>
            <ul className="flex flex-col gap-4">
              <li className="flex items-center gap-4">
                <div className="w-9 h-9 flex items-center justify-center bg-brand-green/20 border border-brand-green-mid rounded-sm shrink-0">
                  <i className="ri-phone-line text-brand-green-accent" />
                </div>
                <a href="tel:+14236780298" className="font-body text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">
                  (423) 678-0298
                </a>
              </li>
              <li className="flex items-center gap-4">
                <div className="w-9 h-9 flex items-center justify-center bg-brand-green/20 border border-brand-green-mid rounded-sm shrink-0">
                  <i className="ri-mail-line text-brand-green-accent" />
                </div>
                <a href="mailto:projects@holstonlandmgmt.com" className="font-body text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">
                  projects@holstonlandmgmt.com
                </a>
              </li>
            </ul>
            <div className="mt-8">
              <Link
                to="/contact"
                className="inline-block px-8 py-3 bg-brand-green hover:bg-brand-green-mid font-heading font-700 text-white text-sm tracking-widest uppercase cursor-pointer whitespace-nowrap transition-colors rounded-sm"
              >
                Get a Quote
              </Link>
            </div>
          </div>
          <div className="h-80 overflow-hidden">
            <iframe
              title="Holston Land Management Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d100950.67527012!2d-82.4535!3d36.3134!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x885a5b0ff7fa3e25%3A0x7d49b1d0e4d2d6a0!2sJohnson%20City%2C%20TN!5e0!3m2!1sen!2sus!4v1234567890"
              className="w-full h-full border-0 grayscale"
              allowFullScreen
              loading="lazy"
            />
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
